import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import { Checkbox } from 'semantic-ui-react';

import { TrackedCheckbox, LoadingPage } from 'Components';
import { resetForm } from 'State/forms/actions';
import { forceDirtyState, resetDirty } from 'State/dirtyTracking/actions';
import { errorToast } from 'Common/ToastHelper';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { KitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { CK_KITCHEN_PREP_WORKSHEET_FORM_NAME } from 'Common/FormEnum';
import {
  ReactTableWrapperColumnProperties,
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
} from 'Common/Constants';
import {
  SortEnum,
  StatusEnum,
  StatusDescEnum,
} from 'Common/Constants/Enumeration/KitchenPrepWorksheet';
import { createToast, toastType } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

import { BASE_URL } from '../../helper/createEditPrepWorksheet';
import * as Selectors from './../../state/kitchenPrepWorksheet/selectors';
import KitchenPrepWorksheetComponent from '../../components/kitchenPrepWorksheetListing/KitchenPrepWorksheet';
import * as actions from './../../state/kitchenPrepWorksheet/actions';

class KitchenPrepWorksheetContainer extends Component {
  reactTableRef = React.createRef();
  state = {
    activeIndexForFilter: 0,
    activeIndexForSort: 0,
    kitchenItemIds: [],
    selectedKitchenItemForClose: [],
  };

  columns = [
    {
      Header: currentRows => {
        const dataObj = currentRows.data;
        const isAllKitchenItemsChecked = this.isAllKitchenItemsChecked(dataObj);
        return (
          <div>
            <Checkbox
              checked={isAllKitchenItemsChecked}
              onChange={(e, data) => {
                e.stopPropagation();
                this.props.forceDirtyState();
                this.checkAll(data.checked, dataObj);
              }}
            />
          </div>
        );
      },
      width: 150,
      accessor: KitchenPrepWorksheetEnum.Select,
      ...ReactTableWrapperColumnProperties,
      visibility: false,
      filterable: false,
      Cell: ({ original }) => {
        const initialValue = _.find(this.props.kitchenPrepWorksheetItems, {
          [KitchenPrepWorksheetEnum.Id]: original[KitchenPrepWorksheetEnum.Id],
        })[KitchenPrepWorksheetEnum.Select];
        return (
          <div style={{ textAlign: 'center' }}>
            <TrackedCheckbox
              initialValue={initialValue}
              checked={this.state.kitchenItemIds.includes(
                original[KitchenPrepWorksheetEnum.Id]
              )}
              onChange={(e, data) => {
                if (data.checked) {
                  this.setState({
                    kitchenItemIds: [
                      ...this.state.kitchenItemIds,
                      original[KitchenPrepWorksheetEnum.Id],
                    ],
                  });
                } else {
                  const kitchenItemIdsCopy = [...this.state.kitchenItemIds];
                  const indexOfItem = kitchenItemIdsCopy.indexOf(
                    original[KitchenPrepWorksheetEnum.Id]
                  );
                  kitchenItemIdsCopy.splice(indexOfItem, 1);
                  this.setState({
                    kitchenItemIds: kitchenItemIdsCopy,
                  });
                }
              }}
            />
          </div>
        );
      },
    },
    {
      Header: 'Id',
      width: 120,
      accessor: KitchenPrepWorksheetEnum.Id,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Kitchen',
      accessor: KitchenPrepWorksheetEnum.Kitchen,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Delivery Date',
      accessor: KitchenPrepWorksheetEnum.DeliveryDate,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Status',
      accessor: KitchenPrepWorksheetEnum.StatusDesc,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Comment',
      accessor: KitchenPrepWorksheetEnum.Comment,
      ...ReactTableWrapperColumnProperties,
    },
    {
      resizable: false,
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.getMenuOptions(gridProps),
        });
      },
    },
  ];

  componentDidMount = async () => {
    const {
      initialValues,
      getWarehouseKitchenList,
      selectedKitchen,
      selectedFromDate,
      selectedToDate,
      selectedStatus,
    } = this.props;
    const beginDT = selectedFromDate
      ? selectedFromDate
      : initialValues[KitchenPrepWorksheetEnum.BeginDT];
    const endDT = selectedToDate
      ? selectedToDate
      : initialValues[KitchenPrepWorksheetEnum.EndDT];
    const kitchenId = selectedKitchen
      ? selectedKitchen
      : initialValues[KitchenPrepWorksheetEnum.WarehouseKitchen];
    const statusOption =
      selectedStatus || selectedStatus === GenericEnum.EmptyString
        ? selectedStatus
        : initialValues[KitchenPrepWorksheetEnum.ViewStatusOptions];
    this.getFilterData(beginDT, endDT, kitchenId, statusOption);
    await getWarehouseKitchenList();
    const { wHKITListData, change } = this.props;
    wHKITListData.length &&
      change(KitchenPrepWorksheetEnum.WarehouseKitchen, GenericEnum.ZeroString);
  };

  componentDidUpdate(prevProps) {
    const {
      clearKitchenErrors,
      closeSuccess,
      printData,
      clearPrintData,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'fetchKitchenPrepWorksheetError') ||
      errorToast(this.props, prevProps, 'fetchWHKITListLoadingError') ||
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'closeError')
    ) {
      clearKitchenErrors();
    } else if (closeSuccess && !prevProps.closeSuccess) {
      createToast(toastType.success, 'Success', closeSuccess, true);
      clearKitchenErrors();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Kitchen Prep Worksheet Print');
      clearPrintData();
    }
  }

  componentWillUnmount() {
    this.clearTableSavedState();
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.CK_KITCHEN_PREP_WORKSHEET_TABLE,
    ]);
  };

  getMenuOptions = gridProps => {
    const { row } = gridProps;
    let menuOptions = [
      {
        icon: 'pencil',
        text:
          row && row.StatusDesc === StatusDescEnum.Closed
            ? 'View'
            : 'View/Edit',
        handler: this.onEditClick,
      },
      {
        icon: 'close',
        text: 'Close',
        disabledWhen: row => row && row.StatusDesc === StatusDescEnum.Closed,
        handler: this.onFulfillmentClose,
      },
    ];

    if (this.state.kitchenItemIds.length > 1) {
      menuOptions = [
        {
          icon: 'close',
          text: 'Close All',
          className: 'danger',
          disabledWhen: row => row.StatusDesc === StatusDescEnum.Closed,
          handler: this.onFulfillmentClose,
        },
      ];
    }
    return menuOptions;
  };

  onFulfillmentClose = row => {
    const {
      kitchenPrepWorksheetItems,
      setNotificationDialog,
      setYesNoDialogProps,
    } = this.props;
    const { kitchenItemIds } = this.state;
    let finalList = [];
    if (kitchenItemIds.length) {
      kitchenItemIds.forEach(id => {
        _.some(kitchenPrepWorksheetItems, obj => {
          if (id === obj.Id) {
            finalList.push(obj);
            return true;
          }
        });
      });
      finalList = finalList.map(item => item.Id);
    } else {
      finalList.push(row.Id);
    }
    const selectedStatus = _.filter(finalList, {
      Status: StatusEnum.Closed,
    });
    if (selectedStatus.length) {
      setNotificationDialog(
        NOTIFICATION_DIALOG_MESSAGES.KITCHEN_PREP_CLOSE_FULFILLMENT_VALIDATION
      );
      return;
    }
    setYesNoDialogProps({
      showDialog: true,
      title: 'Kitchen Prep Worksheet',
      question:
        'Closing a fulfillment will remove any entered prepared amounts. Are you sure you would like to close all selected fulfillments?',
      yesCallback: () => this.onCloseClick(true),
      noCallback: () => this.onCloseClick(false),
    });
    this.setState({
      selectedKitchenItemForClose: finalList,
    });
  };

  onCloseClick = async result => {
    if (result) {
      const {
        closeKitchenPrepWorksheet,
        initialValues,
        selectedKitchen,
        selectedFromDate,
        selectedToDate,
        selectedStatus,
      } = this.props;
      const requestObj = {
        Ids: this.state.selectedKitchenItemForClose,
      };
      await closeKitchenPrepWorksheet(requestObj);
      const beginDT = selectedFromDate
        ? selectedFromDate
        : initialValues[KitchenPrepWorksheetEnum.BeginDT];
      const endDT = selectedToDate
        ? selectedToDate
        : initialValues[KitchenPrepWorksheetEnum.EndDT];
      const kitchenId = selectedKitchen
        ? selectedKitchen
        : initialValues[KitchenPrepWorksheetEnum.WarehouseKitchen];
      const statusOption = selectedStatus
        ? selectedStatus
        : initialValues[KitchenPrepWorksheetEnum.ViewStatusOptions];
      this.getFilterData(beginDT, endDT, kitchenId, statusOption);
    }
  };

  onEditClick = row => {
    const deliveryDate = moment(row.DeliveryDate).format(
      DATE_FORMAT_FOR_SERVER
    );
    this.props.history.push(
      `${BASE_URL}/1/${row.Id}/${deliveryDate}/${this.props.selectedKitchen}`
    );
  };

  isAllKitchenItemsChecked = items => {
    const { kitchenItemIds } = this.state;
    if (
      !items ||
      !Array.isArray(items) ||
      !items.length ||
      !kitchenItemIds.length
    ) {
      return false;
    }
    return items.every(item => {
      const itemId = item[KitchenPrepWorksheetEnum.Id]
        ? item[KitchenPrepWorksheetEnum.Id]
        : item._original[KitchenPrepWorksheetEnum.Id];
      return kitchenItemIds.includes(itemId);
    });
  };

  checkAll = (checked, items) => {
    const kitchenItemIdsCopy = [...this.state.kitchenItemIds];
    if (items && Array.isArray(items) && items.length) {
      items.forEach(item => {
        const itemId = item[KitchenPrepWorksheetEnum.Id]
          ? item[KitchenPrepWorksheetEnum.Id]
          : item._original[KitchenPrepWorksheetEnum.Id];
        const index = kitchenItemIdsCopy.indexOf(itemId);
        if (checked && index === -1) {
          kitchenItemIdsCopy.push(itemId);
        } else if (!checked && index > -1) {
          kitchenItemIdsCopy.splice(index, 1);
        }
      });
      this.setState({
        kitchenItemIds: kitchenItemIdsCopy,
      });
    }
  };

  handleClick = (e, titleProps) => {
    const { index, option } = titleProps;
    const { activeIndexForFilter, activeIndexForSort } = this.state;
    const newIndex = !option
      ? activeIndexForFilter === index
        ? -1
        : index
      : activeIndexForSort === index
        ? -1
        : index;
    !option
      ? this.setState({
          activeIndexForFilter: newIndex,
        })
      : this.setState({
          activeIndexForSort: newIndex,
        });
  };

  onChangeOfFromDT = (e, beginDate, prevBeginDate) => {
    beginDate !== prevBeginDate && this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate, prevEndDate) => {
    endDate !== prevEndDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
    const { selectedToDate, selectedKitchen, selectedStatus } = this.props;
    this.getFilterData(
      beginDate,
      selectedToDate,
      selectedKitchen,
      selectedStatus
    );
  };

  selectToDate = (e, endDate) => {
    this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    const { selectedFromDate, selectedKitchen, selectedStatus } = this.props;
    this.getFilterData(
      selectedFromDate,
      endDate,
      selectedKitchen,
      selectedStatus
    );
  };

  getFilterData = (beginDT, endDate, kitchen, statusOption) => {
    const requestObj = {
      KitchenId: kitchen,
      DateFrom: beginDT,
      DateTo: endDate,
      Status: statusOption,
    };
    this.props.getKitchenPrepWorksheetItems(requestObj);
  };

  setShowStatusOption = value => {
    const { selectedFromDate, selectedKitchen, selectedToDate } = this.props;
    this.getFilterData(
      selectedFromDate,
      selectedToDate,
      selectedKitchen,
      value
    );
  };

  dropDownChange = value => {
    const { selectedFromDate, selectedStatus, selectedToDate } = this.props;
    this.getFilterData(selectedFromDate, selectedToDate, value, selectedStatus);
  };

  printKitchenData = () => {
    let selectedIds = this.getFilteredSelectedKitchenItems();
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: this.props.kitchenPrepWorksheetItems };
    if (selectedIds && !selectedIds.length && dataObjs.sortedData.length) {
      selectedIds[0] = dataObjs.sortedData[0][KitchenPrepWorksheetEnum.Id];
    }
    const requestObj = {
      Ids: selectedIds,
    };
    this.props.printKitchenPrepWorksheetData(requestObj);
  };

  getFilteredSelectedKitchenItems = () => {
    const { kitchenPrepWorksheetItems } = this.props;
    const { kitchenItemIds } = this.state;
    const checkedKitchenItems = [];
    const dataObj =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: kitchenPrepWorksheetItems };
    _.forEach(dataObj.sortedData, obj => {
      const id = obj[KitchenPrepWorksheetEnum.Id]
        ? obj[KitchenPrepWorksheetEnum.Id]
        : obj._original[KitchenPrepWorksheetEnum.Id];
      if (kitchenItemIds.indexOf(id) !== -1) {
        checkedKitchenItems.push(id);
      }
    });
    return checkedKitchenItems;
  };

  clearFilters = () => {
    const { initialValues } = this.props;
    this.props.setFromDateMax(moment().add(1, 'month'));
    this.props.setToDateMin(moment().subtract(1, 'month'));
    this.getFilterData(
      initialValues[KitchenPrepWorksheetEnum.BeginDT],
      initialValues[KitchenPrepWorksheetEnum.EndDT],
      initialValues[KitchenPrepWorksheetEnum.WarehouseKitchen],
      initialValues[KitchenPrepWorksheetEnum.ViewStatusOptions]
    );
    this.setState({
      kitchenItemIds: [],
    });
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(CK_KITCHEN_PREP_WORKSHEET_FORM_NAME);
  };

  render() {
    const {
      wHKITListData,
      fromDateMax,
      toDateMin,
      fetchKitchenPrepWorksheetLoading,
      kitchenPrepWorksheetItems,
      fetchWHKITListLoading,
      printLoading,
      closeLoading,
    } = this.props;
    return fetchWHKITListLoading || closeLoading || printLoading ? (
      <LoadingPage />
    ) : (
      <KitchenPrepWorksheetComponent
        activeIndexForFilter={this.state.activeIndexForFilter}
        activeIndexForSort={this.state.activeIndexForSort}
        handleClick={this.handleClick}
        setShowStatusOption={this.setShowStatusOption}
        printKitchenData={this.printKitchenData}
        columns={this.columns}
        reactTableRef={this.reactTableRef}
        kitchenPrepWorksheetItems={kitchenPrepWorksheetItems}
        fetchKitchenPrepWorksheetLoading={fetchKitchenPrepWorksheetLoading}
        isDisabled={!(wHKITListData && wHKITListData.length)}
        wHKITListData={wHKITListData}
        onChangeOfFromDT={this.onChangeOfFromDT}
        fromDateMax={fromDateMax}
        onChangeOfToDT={this.onChangeOfToDT}
        toDateMin={toDateMin}
        dropDownChange={this.dropDownChange}
        clearFilters={this.clearFilters}
        printLoading={printLoading}
      />
    );
  }
}

const selector = formValueSelector(CK_KITCHEN_PREP_WORKSHEET_FORM_NAME);

const mapStateToProps = state => {
  return {
    kitchenPrepWorksheetItems: Selectors.getKitchenPrepWorksheetItems(state),
    fetchKitchenPrepWorksheetLoading: Selectors.getFetchKitchenPrepWorksheetLoading(
      state
    ),
    fetchWHKITListLoading: Selectors.getFetchWHKITListLoading(state),
    wHKITListData: Selectors.getWHKITListData(state),
    fetchWHKITListLoadingError: Selectors.getFetchWHKITListLoadingError(state),
    fromDateMax: Selectors.getFromDateMax(state),
    toDateMin: Selectors.getToDateMin(state),
    fetchKitchenPrepWorksheetError: Selectors.getFetchKitchenPrepWorksheetError(
      state
    ),
    printLoading: Selectors.getPrintLoading(state),
    printError: Selectors.getPrintError(state),
    closeLoading: Selectors.getCloseLoading(state),
    closeSuccess: Selectors.getCloseSuccess(state),
    closeError: Selectors.getCloseError(state),
    selectedKitchen: selector(state, KitchenPrepWorksheetEnum.WarehouseKitchen),
    selectedFromDate: selector(state, KitchenPrepWorksheetEnum.BeginDT),
    selectedToDate: selector(state, KitchenPrepWorksheetEnum.EndDT),
    selectedStatus: selector(state, KitchenPrepWorksheetEnum.ViewStatusOptions),
    selectedPrintOption: selector(state, KitchenPrepWorksheetEnum.PrintOptions),
    allTableStates: getTableStates(state),
    initialValues: {
      [KitchenPrepWorksheetEnum.WarehouseKitchen]: GenericEnum.ZeroString,
      [KitchenPrepWorksheetEnum.ViewStatusOptions]: StatusEnum.Open,
      [KitchenPrepWorksheetEnum.PrintOptions]: SortEnum.ItemCode,
      [KitchenPrepWorksheetEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [KitchenPrepWorksheetEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
    },
    printData: Selectors.getPrintData(state),
  };
};

KitchenPrepWorksheetContainer = reduxForm({
  form: CK_KITCHEN_PREP_WORKSHEET_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(KitchenPrepWorksheetContainer);

const mapDispatchToProps = {
  ...actions,
  forceDirtyState,
  resetDirty,
  resetForm,
  setTableStates,
  setNotificationDialog,
  setYesNoDialogProps,
};

export const PreparedKitchenItemsComponent = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(KitchenPrepWorksheetContainer)
);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/containers/kitchenPrepWorksheetListing/KitchenPrepWorksheet.js